import { Rowing } from '@mui/icons-material'
import ExpandMore from '@mui/icons-material/ExpandMore'
import { Accordion, AccordionDetails, AccordionSummary } from '@mui/material'
import {
  ArrayInput,
  LinearProgress,
  Loading,
  SimpleFormIterator,
  useArrayInput,
  useGetList,
} from 'react-admin'
import { useWatch } from 'react-hook-form'
import { Empty, FormDataConsumer, SectionLabel, UpsertBoatSection } from '~/components'
import { Sections } from '~/graphql/generated'
import ToolbarAddBoatSection from './ToolbarAddBoatSection'
import './UpsertBoatAttributes.css'

const UpsertBoatAttributes = (props) => {
  const values = useWatch()
  const { data: sections, isLoading } = useGetList<Sections>('sections', {
    pagination: { page: 1, perPage: 25 },
    sort: { field: 'position', order: 'ASC' },
  })

  // Always mounted, empty or not: the field array has to be registered for
  // added sections to count as unsaved changes (see ToolbarAddBoatSection).
  return isLoading ? (
    <LinearProgress />
  ) : (
    <ArrayInput source='boat_section' label='' className='boat-sections'>
      <SimpleFormIterator disableAdd disableRemove disableReordering>
        <FormDataConsumer>
          {({ scopedFormData: { section_id } = {}, getSource, ...rest }) => {
            if (!section_id) {
              return null
            }
            const categorySource = 'boat_section_category'
            const data = sections ? (sections ?? []).find((s) => s.id === section_id) : null

            if (isLoading) return <Loading />
            // The section may not be in the loaded page.
            if (!data) return null

            return (
              <Accordion sx={{ width: '100%' }}>
                <AccordionSummary
                  id={`panel${data.id}-header`}
                  key={data.id}
                  expandIcon={<ExpandMore />}
                >
                  <SectionLabel section={data} />
                </AccordionSummary>
                <AccordionDetails>
                  <UpsertBoatSection
                    section={data}
                    source={categorySource}
                    formData={values}
                    {...props}
                  />
                </AccordionDetails>
              </Accordion>
            )
          }}
        </FormDataConsumer>
      </SimpleFormIterator>
      <NoSections />
      <ToolbarAddBoatSection />
    </ArrayInput>
  )
}

const NoSections = () => {
  const { fields } = useArrayInput()
  return fields.length ? null : (
    <Empty icon={<Rowing />} message='resources.boats.empty_attributes' />
  )
}

export default UpsertBoatAttributes
